import type { SendbirdDataPayload } from '@sendbird/uikit-utils';
import { CHANNEL_CUSTOM_TYPE } from '../constants/chatChannels';

type TChatPushTitleLabels = {
    technicalSupport: string;
    team: string;
};

export const getChatPushTitle = (
    sendbirdData: Partial<SendbirdDataPayload> | null | undefined,
    labels: TChatPushTitleLabels,
    fallbackTitle: string,
): string => {
    switch (sendbirdData?.channel?.custom_type) {
        case CHANNEL_CUSTOM_TYPE.technicalSupport:
            return labels.technicalSupport;
        case CHANNEL_CUSTOM_TYPE.clinical:
            return labels.team;
        default:
            return sendbirdData?.channel?.name || fallbackTitle;
    }
};
